export const SupplierDetails = {
  USERS: { label: 'USERS', value: "USERS" },
  ASSOCIATIONS: { label: 'ASSOCIATIONS', value: "ASSOCIATIONS" },
  LOCATIONS: { label: 'LOCATIONS', value: "LOCATIONS" },
  PURCHASEORDERS: { label: 'POs', value: "PURCHASEORDERS" }
};

